const LS = ($window: ng.IWindowService) => ({
  setData(name: string, val: string) {
    $window.sessionStorage.setItem(name, val);
  },

  removeData(name: string) {
    $window.sessionStorage.removeItem(name);
  },

  getData(name: string) {
    return $window.sessionStorage.getItem(name);
  },
});

LS.$inject = ['$window'];

export default LS;
